import React from 'react';
import { Head } from '@shared/index';
import {
  ActionsBarRoot,
  BoxInformativeToPay,
  Container,
  ContainerBody,
  ContainerHead,
  Description,
  Label1,
  Label2,
  Label3,
  Title,
} from './ReserveApplicationScreen.styled';
import Image from 'next/image';
import { CompactEstateCard } from '../CompactEstateCard/CompactEstateCard';
import { AptunoButton, Icon, SIZES, VARIANTS } from '@aptuno/aptuno-ui';

export const dataTesting = {
  title: 'Vereda el Rosario, Medellín',
  price: 1500,
  rooms: 1,
  bathrooms: 1,
  area: 50,
  imgState: 'https://cdn.aptuno.com/properties-images/970/dbecaa62-6648-4edd-a150-b691f15cd96e_thumb.jpg',
};

export const ReserveApplicationScreen = () => {
  return (
    <Container>
      <Head
        title={'Reservar Inmueble | Aptuno'}
        description={'Reserva ya el inmueble de tus sueños!'}
        image={'https://www.aptuno.com/images/aptuno_logo.png'}
        url={'https://www.aptuno.com/aplicar-inmueble/reserva-aplicacion'}
      />

      <ContainerHead>
        <Image
          src={'/images/flower2.svg'}
          width={82}
          height={32}
          alt="Resultados de Mis Aplicaciones | Aptuno"
          title="Resultado de Aplicaciones | Aptuno"
        />
        <Title>Reservarás este inmueble</Title>
      </ContainerHead>

      <ContainerBody>
        <CompactEstateCard
          imageUrl={dataTesting.imgState}
          title={dataTesting.title}
          price={dataTesting.price}
          administatrionFee={0}
          rooms={dataTesting.rooms}
          bathrooms={dataTesting.bathrooms}
          squareMeters={dataTesting.area}
        />

        <Description>
          Para reservar este inmueble, <strong>pagarás el 30% del valor mensual del canon </strong>. Este valor es
          totalmente abonable a tu primer mes de arriendo.
        </Description>

        <BoxInformativeToPay>
          <Label1>Pagarás aproximadamente:</Label1>
          <Label2>$703.500</Label2>
        </BoxInformativeToPay>

        <Label3>Al reservar este inmueble, lo quitaremos de nuestro catálogo para que nadie más pueda tomarlo.</Label3>
      </ContainerBody>

      <ActionsBarRoot>
        <AptunoButton appearance={VARIANTS.SECONDARY} size={SIZES.MEDIUM} onClick={() => alert('BACK TEST CLICK')}>
          <Icon width="12px" height="12px" icon="arrowleftalt" />
          Regresar
        </AptunoButton>
        <AptunoButton appearance={VARIANTS.PRIMARY} size={SIZES.BIGGEST} onClick={() => alert('NEXT TEST CLICK')}>
          {false ? 'Guardando Información...' : 'Continuar'}
          <Icon width="12px" height="12px" icon="Arrow_Right" />
        </AptunoButton>
      </ActionsBarRoot>
    </Container>
  );
};
